
import {SegmentPanel} from "../segment/segmentpanel";

class SiteSelector {
    static #showing = false;

    static show() {
        console.log("test");
        let dropDown  = document.querySelector("#select-website-dropdown .top-dropdown-child");

        if (!this.#showing) {
            let self = this;
            setTimeout(function () {
                document.addEventListener("click", function (event) {
                    self.hide();
                }, {once: true});
            }, 1);
        }

        dropDown.style.display = "block";
        this.#showing = true;
    }

    static hide() {
        let dropDown  = document.querySelector("#select-website-dropdown .top-dropdown-child");
        dropDown.style.display = "none";
        this.#showing = false;
    }
}

window.addEventListener("load", function () {

    // register click that will show the dropdown that has all the available websites
    let selectWebsiteDropdown = document.querySelector("#select-website-dropdown")
    if (selectWebsiteDropdown !== null) {
        selectWebsiteDropdown.addEventListener("click", function () {
            SiteSelector.show();
        });
    }

    // handles when a website is clicked
    Array
        .from(document.querySelectorAll(".website-selector"))
        .forEach(el => {
            el.addEventListener("click", function () {
                let match = window.location.pathname.match(/^(\/account\/view\/)([0-9]+)(\/.*)$/)
                let propertyId = el.getAttribute("data-property-id");
                window.location = match[1]+propertyId+match[3];
            });
        });
});